<template>
  <div>
    <pcHeader></pcHeader>
    <div class="pc_goods_list_box">
      <div class="pc_goods_list_nav clearfix_">
        <div class="clearfix_ fl">
          <div @click="gotoIndex" class="pc_goods_list_nav_item fl">首页&nbsp<span>></span>&nbsp</div>
          <div @click="gotoCategory(item.id)" v-for="(item,index) in categoryStr" :key="index" class="pc_goods_list_nav_item fl">{{item.name}}&nbsp<span>></span>&nbsp</div>
        </div>
        <div class="fl pc_goods_list_nav_selected clearfix_">
          <div v-show="brandNames" class="pc_goods_list_nav_selected_item clearfix_ fl">
            <div class="fl">品牌：</div>
            <div class="fl pc_goods_list_nav_selected_item_txt"><span :title="brandNames">{{brandNames}}</span></div>
            <div @click="deleteBrand" class="pc_goods_list_nav_selected_item_delete fl">×</div>
          </div>
          <div v-show="categoryNames" class="pc_goods_list_nav_selected_item clearfix_ fl">
            <div class="fl">分类：</div>
            <div class="fl pc_goods_list_nav_selected_item_txt"><span :title="categoryNames">{{categoryNames}}</span></div>
            <div @click="deleteCategory" class="pc_goods_list_nav_selected_item_delete fl">×</div>
          </div>
          <div v-for="(item,index) in attrNavList" :key="index" class="pc_goods_list_nav_selected_item clearfix_ fl">
            <div class="fl">{{item.name}}：</div>
            <div class="fl pc_goods_list_nav_selected_item_txt"><span :title="item.valNames">{{item.valNames}}</span></div>
            <div @click="deleteAttr(item,index)" class="pc_goods_list_nav_selected_item_delete fl">×</div>
          </div>
        </div>
      </div>
      <div class="pc_goods_list_screen_box">
        <div v-show="brandList.length&&brandNames==''" class="pc_screen_brand clearfix_">
          <div class="fl pc_screen_brand_title">品牌：</div>
          <div class="fl pc_screen_brand_content clearfix_">
            <div class="fl pc_screen_brand_content_list ">
              <div class="clearfix_" :class="{pc_screen_brand_content_list_auto:isMoreBrand}">
                <div v-for="(item,index) in brandList" :key="index" @mouseenter="brandenter(item)" @mouseleave="brandleave(item)" @click="brandCheck(item)" :class="{pc_screen_brand_content_item_active:item.isChecked}" class="fl pc_screen_brand_content_item">
                  <div v-show="!item.isBlock" class="pc_screen_brand_content_item_txt">{{item.name}}</div>
                  <div v-show="item.isBlock" class="pc_screen_brand_content_item_img"><img :src="item.pic" alt=""></div>
                  <div v-show="item.isChecked" class="pc_screen_brand_content_item_checked"><img src="http://img.source.9188cn.com/brand_selected.png" alt=""></div>
                </div>
              </div>
              <div class="clearfix_ pc_screen_brand_content_checked">
                <div @click="defineBrand" class="fl">确定</div>
                <div @click="cancelMoreBrandCheck" class="fl">取消</div>
              </div>
            </div>
            <div v-show="brandBtnIsShow" class="fr pc_screen_brand_content_more">
              <div :style="{opacity:(brandList.length>7?'1':'0')}" @click="moreBrandShow" class="fl">{{isMoreBrand?'收起':'更多'}}<img src="http://img.source.9188cn.com/pc_more.png" alt=""></div>
              <div @click="moreBrandCheck" class="fl">多选<img src="http://img.source.9188cn.com/pc_bottom_btn.png" alt=""></div>
            </div>
          </div>
        </div>
        <div v-show="mallCategoryData.length&&categoryNames==''" class="pc_screen_category clearfix_">
          <div class="fl pc_screen_brand_title">分类：</div>
          <div class="fl pc_screen_category_content clearfix_">
            <div class="fl pc_screen_category_content_list ">
              <div class="clearfix_" :class="{pc_screen_brand_category_list_auto:isMoreCategory}">
                <div v-for="(item,index) in mallCategoryData" :key="index" @click="categoryCheck(item)" :class="{pc_screen_category_content_item_active:item.isChecked}" class="fl pc_screen_category_content_item">{{item.name}}</div>
              </div>
              <div class="clearfix_ pc_screen_brand_content_checked">
                <div @click="defineCategory" class="fl">确定</div>
                <div @click="cancelMoreCategoryCheck" class="fl">取消</div>
              </div>
            </div>
            <div v-show="categoryBtnIsShow" class="fr pc_screen_brand_content_more pc_screen_category_content_more">
              <div @click="moreCategoryShow" class="fl">{{isMoreCategory?'收起':'更多'}}<img src="http://img.source.9188cn.com/pc_more.png" alt=""></div>
              <div @click="moreCategoryCheck" class="fl">多选<img src="http://img.source.9188cn.com/pc_bottom_btn.png" alt=""></div>
            </div>
          </div>
        </div>
        <div v-show="item.value.length&&item.isShow" v-for="(item,index) in attrList" :key="index" :style="{height:item.height}" class="pc_screen_attr clearfix_">
          <div class="fl pc_screen_brand_title">{{item.name}}：</div>
          <div class="fl pc_screen_category_content clearfix_">
            <div class="fl pc_screen_category_content_list ">
              <div class="clearfix_" :class="{pc_screen_brand_category_list_auto:item.isMoreAttr}">
                <div v-for="(val,idx) in item.value" :key="idx" @click="attrCheck(item,val)" :class="{pc_screen_category_content_item_active:val.isChecked}" class="fl pc_screen_category_content_item">{{val.name}}</div>
              </div>
              <div class="clearfix_ pc_screen_brand_content_checked">
                <div @click="defineAttr(item)" class="fl">确定</div>
                <div @click="cancelMoreAttrCheck(item)" class="fl">取消</div>
              </div>
            </div>
            <div v-show="item.attrBtnIsShow" class="fr pc_screen_brand_content_more pc_screen_category_content_more">
              <div @click="moreAttrShow(item)" class="fl">{{item.isMoreAttr?'收起':'更多'}}<img src="http://img.source.9188cn.com/pc_more.png" alt=""></div>
              <div @click="moreAttrCheck(item)" class="fl">多选<img src="http://img.source.9188cn.com/pc_bottom_btn.png" alt=""></div>
            </div>
          </div>
        </div>

      </div>
      <div class="pc_goods_list_goods clearfix_">
        <div class="fl pc_goods_left">
          <div class="pc_goods_left_title">最新销售</div>
          <div class="pc_goods_left_list">
            <div @click="gotoGoodsDetail(item)" v-for="(item,index) in goodsLeftList" :key="index" class="pc_goods_left_item">
              <div class="pc_goods_left_item_img"><img :src="item.goodsHeadpicPath1?item.goodsHeadpicPath1:noImg" alt=""></div>
              <div class="pc_goods_left_item_name">{{item.name}}</div>
              <div class="pc_goods_left_item_price">¥{{item.price}}</div>
            </div>
          </div>
        </div>
        <div ref="getHeight" class="fr pc_goods_right">
          <div class="pc_goods_right_nav clearfix_">
            <div @click="sortGoodsList('综合')" :style="{color:(sortName=='dateCreated'?'#fff':'#333'),background:(sortName=='dateCreated'?'#e4393c':'#fff')}" class="pc_goods_right_nav_item fl">综合</div>
            <div @click="sortGoodsList('销量')" :style="{color:(sortName=='sum'?'#fff':'#333'),background:(sortName=='sum'?'#e4393c':'#fff')}" class="pc_goods_right_nav_item fl">销量</div>
            <div @click="sortGoodsList('价格')" :style="{color:(sortName=='price'?'#fff':'#333'),background:(sortName=='price'?'#e4393c':'#fff')}" class="pc_goods_right_nav_item pc_goods_right_nav_price fl clearfix_"><div class="pc_goods_right_nav_price_txt fl">价格</div><div class="pc_goods_right_nav_price_img fl"></div></div>
            <div class="pc_goods_right_nav_item_price clearfix_">
              <div class="fl pc_goods_right_nav_item_price_min"><input placeholder="¥" type="number" v-model="minPrice"></div>
              <div class="fl pc_goods_right_nav_item_price_to">-</div>
              <div class="fl pc_goods_right_nav_item_price_max"><input placeholder="¥" type="number" v-model="maxPrice"></div>
            </div>
          </div>
          <div class="pc_goods_right_list clearfix_">
            <div @click="gotoGoodsDetail(item)" v-for="(item,index) in categoryList" :key="index" class="pc_goods_right_item fl">
              <div class="pc_goods_right_item_img"><img :src="item.goodsHeadpicPath1?item.goodsHeadpicPath1:noImg" alt=""></div>
              <div class="pc_goods_right_item_price">¥{{item.price}} <span v-show="item.price!=item.lrprice">¥{{item.lrprice}}</span> </div>
              <div class="pc_goods_right_item_name">{{item.name}}</div>
              <div class="pc_goods_right_item_btn_box clearfix_">
                <div class="fl pc_goods_right_item_btn1">查看详情</div>
                <div class="fl pc_goods_right_item_btn1 pc_goods_right_item_btn2">立即购买</div>
              </div>
            </div>
          </div>
          <div class="pc_goods_list_page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="12"
              layout="prev, pager, next, jumper"
              :total="this.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <pcBackTop></pcBackTop>
  </div>
</template>
<style scoped>
.pc_goods_list_box{
  padding-top: 20px;
  padding-bottom: 50px;
  width: 1200px;
  margin: 0 auto;
}
.pc_goods_list_nav{
  margin-bottom: 20px;
}
.pc_goods_list_nav_item{
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.pc_goods_list_nav_item:last-child span{
  display: none;
}
.pc_screen_brand{
  width: 1198px;
   height: 70px; 
  background: #fff;
  border: 1px solid transparent;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  overflow: hidden;
}
.pc_screen_brand_title{
  width: 100px;
  height: 100%;
  line-height: 34px;
  background: #f3f3f3;
  padding-left: 10px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_screen_brand_content{
  padding: 10px;
  padding-bottom: 0;
  width: 1068px;
}
.pc_screen_brand_content_list{
  width: 930px;
}
.pc_screen_brand_content_list_auto{
  height: 122px;
  overflow-y: auto;
}
.pc_screen_brand_content_item{
  width: 114px;
  height: 48px;
  border: 1px solid #ddd;
  margin: 0px 15px 11px 0;
  cursor: pointer;
  position: relative;
}
.pc_screen_brand_content_item_txt{    
  line-height: 48px;
  padding: 0 7px;
  line-height: 48px;
  text-align: center;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_screen_brand_content_item_img{
  width: 114px;
  height: 48px;
}
.pc_screen_brand_content_item_img img{
  width: 114px;
  height: 48px;
}
.pc_screen_brand_content_item:hover{
  border: 1px solid #f60;
  position: relative;
}
.pc_screen_brand_content_item_active{
  border: 1px solid #f60;
  position: relative;
}
/* .pc_screen_brand_content_item:hover .pc_screen_brand_content_item_img{
  display: none;
}
.pc_screen_brand_content_item:hover .pc_screen_brand_content_item_txt{
  display: block;
} */
.pc_screen_brand_content_more{
  width: 114px;
  height: 25px;
}
.pc_screen_brand_content_more>div{
  width: 45px;
  height: 23px;
  line-height: 23px;
  border: 1px solid #ddd;
  padding-left: 5px;
  cursor: pointer;
}
.pc_screen_brand_content_more>div:first-child{
  margin-right: 10px;
}
.pc_screen_brand_content_more img{
  width: 15px;
  height: 15px;
  margin-left: 3px;
  margin-top: 3px;
}
.pc_screen_brand_content_checked{
  width: 112px;
  margin: 0 auto;
}
.pc_screen_brand_content_checked div{
  width: 50px;
  height: 24px;
  border: 1px solid #ddd;
  background: #f7f7f7;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.pc_screen_brand_content_checked div:first-child{
  margin-right: 8px;
}
.pc_screen_brand_content_item_checked{
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.pc_screen_brand_content_item_checked{
  width: 16px;
  height: 16px;
}
.pc_goods_list_nav_selected_item{
  padding-left: 10px;
  background: #f3f3f3;
  border: 1px solid #ddd;
  cursor: pointer;
  line-height: 22px;
  margin-right: 15px;
}
.pc_goods_list_nav_selected_item:hover{
  background: #fff;
  border: 1px solid #e4393c;
}
.pc_goods_list_nav_selected_item_txt{
  color: #e4393c;
  max-width: 200px;
  height: 22px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin-right: 2px;
}
.pc_goods_list_nav_selected_item_delete{
  font-size: 16px;
  color: #e4393c;
  padding: 0 10px;
}
.pc_goods_list_nav_selected_item:hover .pc_goods_list_nav_selected_item_delete{
  background: #e4393c;
  color:#fff;
}
.pc_screen_category_content{
  width: 1078px;
}
.pc_screen_category_content_list{
  width: 930px;
}
.pc_screen_category_content_item{
  line-height: 34px;
  padding: 0 10px;
  cursor: pointer;
}
.pc_screen_category_content_item:hover{
  color: #f60;
}
.pc_screen_category_content_item_active{
  color: #f60;
}
.pc_screen_category{
  width: 1198px;
  height: 34px;
  background: #fff;
  border: 1px solid transparent;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  overflow: hidden;
  margin-top: -1px;
}
.pc_screen_attr{
  width: 1198px;
  height: 34px;
  background: #fff;
  border: 1px solid transparent;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  overflow: hidden;
  margin-top: -1px;
}
.pc_screen_category_content_more{
  margin-top: 5px;
}
.pc_screen_brand_category_list_auto{
  height: 68px;
  overflow-y: auto;
}
.pc_goods_list_goods{
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
}
.pc_goods_left{
  width: 193px;
}
.pc_goods_left_title{
  width: 191px;
  border: 1px solid #ededed;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #2c3e50;
  font-size: 14px;
  background: #fafafa;
}
.pc_goods_left_item{
  padding: 10px;
  border: 1px solid #ededed;
  border-top: 0;
  background: #fff;
}
.pc_goods_left_item_img{
  width: 171px;
  height: 171px;
  margin-bottom: 10px;
}
.pc_goods_left_item_img img{
  width: 171px;
  height: 171px;
}
.pc_goods_left_item_name{
  width: 100%;
  line-height: 16px;
  margin-bottom: 10px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.pc_goods_left_item_name:hover{
  color: #f60;
}
.pc_goods_left_item_price{
  color: #f60;
}
.pc_goods_right{
  width: 993px;
}
.pc_goods_right_nav{
  padding: 8px;
  height: 24px;
  border: 1px solid #ccc;
  background: #f6f6f6;
  margin-bottom: 10px;
}
.pc_goods_right_nav_item{
  color:#333;
  display: block;
  width: 54px;
  height: 22px;
  border: 1px solid #ccc;
  line-height: 22px;
  font-size: 12px;
  background: #fff;
  cursor: pointer;
  text-align: center;
  margin-right: 5px;
}
.pc_goods_right_nav_price{
  width: 44px;
  padding-left: 10px;
  text-align: left;
}
.pc_goods_right_nav_price_txt{
  margin-right: 5px;
}
.pc_goods_right_nav_price_img{
  width: 7px;
  height: 11px;
  margin-top: 7px;
  background: url('http://img.source.9188cn.com/pc_sort_none.png');
}
.pc_goods_right_nav_item_price_min,.pc_goods_right_nav_item_price_max{
  width: 54px;
  height: 22px;
  border: 1px solid #ccc;
  background: #fff;
  margin-right: 5px;
}
.pc_goods_right_nav_item_price_min input,.pc_goods_right_nav_item_price_max input{
  width: 50px;
  height: 22px;
  padding-left: 4px;
  outline: none;
}
.pc_goods_right_nav_item_price_to{
  line-height: 24px;
  margin-right: 5px;
}
input[type=number] {  
  -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
  -webkit-appearance: none;  
  margin: 0;  
}  
.pc_goods_right_item{
  width: 224px;
  height: 353px;
  border: 1px solid transparent;
  padding: 10px;
  background: #fff;
}
.pc_goods_right_item:hover{
  border: 1px solid #ebebeb;
}
.pc_goods_right_item:hover .pc_goods_right_item_btn_box{
  display: block;
}
.pc_goods_right_item_img{
  width: 224px;
  height: 224px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.pc_goods_right_item_img img{
  width: 224px;
  height: 224px;
}
.pc_goods_right_item_price{
  font-size: 22px;
  color: #f60;
  margin-bottom: 10px;
}
.pc_goods_right_item_price span{
  font-size: 12px;
  color: #666;
  text-decoration: line-through;
}
.pc_goods_right_item_name{
  height: 35px;
  line-height: 19px;
  color: #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 10px;
}
.pc_goods_right_item_name:hover{
  color: #f60;
}
.pc_goods_right_item_btn_box{
  height: 30px;
  border-top: 1px solid #eee;
  display: none;
}
.pc_goods_right_item_btn1{
  width: 111px;
  height: 30px;
  line-height: 30px;
  color:#f60;
  font-size: 14px;
  text-align: center;
  border-right: 1px solid #eee;
  cursor: pointer;
}
.pc_goods_right_item_btn2{
  width: 112px;
  border-right: 0;
}
.pc_goods_list_page{
  text-align: center;
}
.pc_goods_right_list{
  margin-bottom: 20px;
}
</style>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import pcHeader from '@/components/index/search'
import pcBackTop from '@/components/common/BackTop'
export default {
  data(){
    return {
      noImg:require("@/assets/img/aa.png"),
      categoryList:[],
      goodsLeftList:[],
      salesGoodsPageSize:1,
      page:1,
      total:null,
      categoryStr:[],
      brandList:[],
      brandIds:[],
      brandNamesArr:[],
      brandNames:'',
      isMoreBrand:false,
      brandBtnIsShow:true,
      mallCategoryData:[],
      isMoreCategory:false,
      categoryBtnIsShow:true,
      categoryIds:[],
      categoryNamesArr:[],
      categoryNames:'',
      attrList:[],
      attrNavList:[],
      sortName:'dateCreated',
      priceType:0,
      minPrice:'',
      maxPrice:''
    }
  },
  components:{
    pcHeader,pcBackTop
  },
  mounted:function(){
    var t_=this
    t_.getGoodsByCategoryId(t_.page)
    t_.getScreen()
    fn()
    function fn(){
      setTimeout(()=>{
        if($('.pc_goods_right_item').length==0){
          fn()
        }else{
          t_.salesGoodsPageSize=Math.floor(t_.$refs.getHeight.offsetHeight/260)
          t_.salesGoods()
        }
      },50,t_)
    }
    
  },
  methods:{
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      return window.open(href.href,'_blank')
    },
    goSignIn:function(){
      localStorage.removeItem('tamp')
      localStorage.removeItem('name')
      return this.$router.push({
        name: 'loginHome',
        query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
      });
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.page=val
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(val)
    },
    gotoGoodsDetail:function(item){
      var href=this.$router.resolve({name:'goodsdetails',query:{goodsId:item.goodsId,supplyChainTenantId:item.supplyChainTenantId,isSupplyChainGoods:2}})
      return window.open(href.href,'_blank')
    },
    gotoCategory:function(id){
      var href=this.$router.resolve({name:'goodslist',query:{id:id}})
      return window.open(href.href,'_blank')
    },
    gotoIndex:function(){
      this.$router.push({
        name: 'home'
      })
    },
    sortGoodsList:function(str){
      if(str=='综合'){
        if(this.sortName=='dateCreated')return
        this.sortName='dateCreated'
        this.priceType=0
        $('.pc_goods_right_nav_price_img').css('background','url("http://img.source.9188cn.com/pc_sort_none.png")')
      }else if(str=='销量'){
        if(this.sortName=='sum')return
        this.sortName='sum'
        this.priceType=0
        $('.pc_goods_right_nav_price_img').css('background','url("http://img.source.9188cn.com/pc_sort_none.png")')
      }else if(str=='价格'){
        this.sortName='price'
        if(this.priceType==0){
          this.priceType=1
        }else if(this.priceType==1){
          this.priceType=2
        }else if(this.priceType==2){
          this.priceType=1
        }
      }
      
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    moreBrandShow:function(){
      if(this.isMoreBrand){
        this.isMoreBrand=false
        $('.pc_screen_brand').height(70)
      }else{
        this.isMoreBrand=true
        $('.pc_screen_brand').height(132)
      }
    },
    moreCategoryShow:function(){
      if(this.isMoreCategory){
        this.isMoreCategory=false
        $('.pc_screen_category').height(34)
      }else{
        this.isMoreCategory=true
        $('.pc_screen_category').height(68)
      }
    },
    moreAttrShow:function(item){
      if(item.isMoreAttr){
        item.isMoreAttr=false
        item.height='34px'
      }else{
        item.isMoreAttr=true
        item.height='68px'
      }
    },
    brandCheck:function(obj){
      if(this.brandBtnIsShow){
        this.brandIds=[]
        this.brandNames=''
        this.brandIds.push(obj.id)
        this.brandNames=obj.name
        this.page=1
        window.scrollTo(0,0)
        this.getGoodsByCategoryId(this.page)
      }else{
        if(obj.isChecked){
          obj.isChecked=false
          this.brandIds.splice(this.brandIds.indexOf(obj.id),1)
          this.brandNamesArr.splice(this.brandNamesArr.indexOf(obj.name),1)
        }else{
          obj.isChecked=true
          this.brandIds.push(obj.id)
          this.brandNamesArr.push(obj.name)
        }
      }
    },
    categoryCheck:function(obj){
      if(this.categoryBtnIsShow){
        this.categoryIds=[]
        this.categoryNames=''
        this.categoryIds.push(obj.id)
        this.categoryNames=obj.name
        this.page=1
        window.scrollTo(0,0)
        this.getGoodsByCategoryId(this.page)
      }else{
        if(obj.isChecked){
          obj.isChecked=false
          this.categoryIds.splice(this.categoryIds.indexOf(obj.id),1)
          this.categoryNamesArr.splice(this.categoryNamesArr.indexOf(obj.name),1)
        }else{
          obj.isChecked=true
          this.categoryIds.push(obj.id)
          this.categoryNamesArr.push(obj.name)
        }
      }
    },
    attrCheck:function(item,val){
      if(item.attrBtnIsShow){
        item.attrIds=[]
        item.attrNames=''
        item.attrIds.push(val.proid)
        item.attrNames=val.name
        item.isShow=false
        var obj={
          name:item.name,
          id:item.id,
          valIds:item.attrIds,
          valNames:item.attrNames
        }
        this.attrNavList.push(obj)
        this.page=1
        window.scrollTo(0,0)
        this.getGoodsByCategoryId(this.page)
      }else{
        if(val.isChecked){
          val.isChecked=false
          item.attrIds.splice(item.attrIds.indexOf(val.proid),1)
          item.attrNamesArr.splice(item.attrNamesArr.indexOf(val.name),1)
        }else{
          val.isChecked=true
          item.attrIds.push(val.proid)
          item.attrNamesArr.push(val.name)
        }
        
      }
    },
    defineBrand:function(){
      if(!this.brandIds.length)return
      this.brandNames=this.brandNamesArr.join(',')
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    defineCategory:function(){
      if(!this.categoryIds.length)return
      this.categoryNames=this.categoryNamesArr.join(',')
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    defineAttr:function(item){
      if(!item.attrIds.length)return
      var obj={
        name:item.name,
        id:item.id,
        valIds:item.attrIds,
        valNames:item.attrNamesArr.join(',')
      }
      item.isShow=false
      this.attrNavList.push(obj)
      console.log( this.attrNavList )
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    deleteBrand:function(){
      this.brandBtnIsShow=true
      this.isMoreBrand=false
      this.brandIds=[]
      this.brandNamesArr=[]
      this.brandNames=''
      this.brandList.forEach(function(item,index){
        item.isChecked=false
      })
      $('.pc_screen_brand').height(70)
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    deleteCategory:function(){
      this.categoryBtnIsShow=true
      this.isMoreCategory=false
      this.categoryIds=[]
      this.categoryNamesArr=[]
      this.categoryNames=''
      this.mallCategoryData.forEach(function(item,index){
        item.isChecked=false
      })
      $('.pc_screen_category').height(34)
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    deleteAttr:function(obj,idx){
      this.attrList.forEach(function(item,index){
        if(item.id==obj.id){
          item.attrBtnIsShow=true
          item.isMoreAttr=false
          item.attrIds=[]
          item.attrNamesArr=[]
          item.attrNames=''
          item.value.forEach(function(val,idx){
            val.isChecked=false
          })
         item.height='34px'
         item.isShow=true
        }
      })
      this.attrNavList.splice(idx,1)
      this.page=1
      window.scrollTo(0,0)
      this.getGoodsByCategoryId(this.page)
    },
    moreBrandCheck:function(){
      if(this.isMoreBrand){
        this.isMoreBrand=false
        $('.pc_screen_brand').height(70)
      }else{
        this.isMoreBrand=true
        this.brandBtnIsShow=false
        this.brandIds=[]
        this.brandNamesArr=[]
        this.brandNames=''
        $('.pc_screen_brand').height(170)
      }
    },
    moreCategoryCheck:function(){
      if(this.isMoreCategory){
        this.isMoreCategory=false
        $('.pc_screen_category').height(34)
      }else{
        this.isMoreCategory=true
        this.categoryBtnIsShow=false
        this.categoryIds=[]
        this.categoryNamesArr=[]
        this.categoryNames=''
        $('.pc_screen_category').height(100)
      }
    },
    moreAttrCheck:function(item){
      if(item.isMoreAttr){
        item.isMoreAttr=false
        item.height='34px'
      }else{
        item.isMoreAttr=true
        item.attrBtnIsShow=false
        item.attrIds=[]
        item.attrNamesArr=[]
        item.attrNames=''
        item.height='100px'
      }
    },
    cancelMoreBrandCheck:function(){
      this.brandBtnIsShow=true
      this.isMoreBrand=false
      this.brandIds=[]
      this.brandNamesArr=[]
      this.brandNames=''
      this.brandList.forEach(function(item,index){
        item.isChecked=false
      })
      $('.pc_screen_brand').height(70)
    },
    cancelMoreCategoryCheck:function(){
      this.categoryBtnIsShow=true
      this.isMoreCategory=false
      this.categoryIds=[]
      this.categoryNamesArr=[]
      this.categoryNames=''
      this.mallCategoryData.forEach(function(item,index){
        item.isChecked=false
      })
      $('.pc_screen_category').height(34)
    },
    cancelMoreAttrCheck:function(item){
      item.attrBtnIsShow=true
      item.isMoreAttr=false
      item.attrIds=[]
      item.attrNamesArr=[]
      item.attrNames=''
      item.value.forEach(function(val,idx){
        val.isChecked=false
      })
      item.height='34px'
    },
    getGoodsByCategoryId:function(page){
      var t_=this
      let data = {
        categoryid:t_.$route.query.id?t_.$route.query.id:'',
        channel:2,
        pagesize:12,
        page:page,
        tamp:localStorage.tamp?localStorage.tamp:'',
        sortName:t_.sortName
      }
      console.log( t_.$route.query )
      if(t_.$route.query.txt)data.goodsContion=t_.$route.query.txt
      if(t_.brandIds.length)data.brandIds=t_.brandIds.join(',')
      if(t_.attrNavList.length){
        var str=''
        t_.attrNavList.forEach(function(item,index){
          item.valIds.forEach(function(val,idx){
            str+=val+','
          })
        })
      }
      data.attributeIds=str
      if(data.sortName=='price'){
        if(t_.priceType==1){
          data.sort=1
        }else if(t_.priceType==2){
          data.sort=2
        }
      }
      if(t_.minPrice||t_.maxPrice){
        if(t_.minPrice&&t_.maxPrice){
          if(parseInt(t_.minPrice)>parseInt(t_.maxPrice))return t_.$message({
            message:'最小金额不能大于最大金额哦~！',
            center:true,
            type:'warning'
          })
        }
        if(t_.minPrice)data.priceSmall=t_.minPrice
        if(t_.maxPrice)data.priceBig=t_.maxPrice
      }
      if(t_.categoryIds.length)data.categoryid=t_.categoryIds.join(',')
      axios.post(`${ip}formWorkInterface/getGoodsByCategoryId`,Qs.stringify(data)).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.categoryStr = res.data.results.categoryData
          if(res.data.results.mallCategoryData){
            res.data.results.mallCategoryData.forEach(function(item,index){
              t_.$set(item,'isChecked',false)
            })
            t_.mallCategoryData=res.data.results.mallCategoryData
          }
          t_.categoryList=res.data.results.rows
          t_.total=res.data.results.total
          if(data.sortName=='price'&&data.sort==1){
            $('.pc_goods_right_nav_price_img').css('background','url("http://img.source.9188cn.com/pc_sort_desc.png")')
          }else if(data.sortName=='price'&&data.sort==2){
            $('.pc_goods_right_nav_price_img').css('background','url("http://img.source.9188cn.com/pc_sort_asc.png")')
          }
        }
        
      })
    },
    brandenter:function(obj){
      if(!obj.pic)return
      obj.isBlock=false
    },
    brandleave:function(obj){
      if(!obj.pic)return
      obj.isBlock=true
    },
    getScreen:function () {
      var t_ = this
      let data = Qs.stringify({"categoryid":this.$route.query.id,"channel":2,"search":'',tamp:localStorage.tamp?localStorage.tamp:''});
      axios.post(`${ip}formWorkInterface/screening`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          if(res.data.data.brand.length){
            var arr=[]
            res.data.data.brand.forEach(function(item,index){
              item.item_list.forEach(function(val,idx){
                t_.$set(val,'isChecked',false)
                if(val.pic){
                  t_.$set(val,'isBlock',true)
                }else{
                  t_.$set(val,'isBlock',false)
                }
                arr.push(val)
                
              })
            })
            t_.brandList=arr
          }
          if(res.data.data.attribute.length){
            res.data.data.attribute.forEach(function(item,index){
              t_.$set(item,'isMoreAttr',false)
              t_.$set(item,'isShow',true)
              t_.$set(item,'attrBtnIsShow',true)
              t_.$set(item,'height','34px')
              t_.$set(item,'attrIds',[])
              t_.$set(item,'attrNamesArr',[])
              t_.$set(item,'attrNames','')
              item.value.forEach(function(val,idx){
                t_.$set(val,'isChecked',false)
              })
            })
            t_.attrList=res.data.data.attribute
          }
        }
      })
    },
    salesGoods:function () {
      var t_=this
      var data = {
        channel:2,
        pagesize:t_.salesGoodsPageSize,
        page:1,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      if(t_.$route.query.id)data.categoryId=t_.$route.query.id
      if(t_.$route.query.goodsId)data.goodsId=t_.$route.query.goodsId
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/salesGoods`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.goodsLeftList = res.data.results.rows
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/goodsList/index.vue